import { Button } from "@mui/material";
import React from "react";

interface IProps {
  isActive?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

function LinkButton({
  children,
  isActive = false,
  onClick = () => {},
}: IProps) {
  return (
    <Button
      sx={{ textTransform: "none" }}
      variant="text"
      color={isActive ? "primary" : "secondary"} // Explicit color when not active
      onClick={onClick}
    >
      {children}
    </Button>
  );
}

export default LinkButton;
